import type {ReactElement} from 'react';
import React from 'react';
import type {ItemMobileGlowEffectOptionsProps} from './item-mobile-glow-effect-options.types';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import {SlideshowItemGlowEffectOptions} from '@Panels/poster-editor-item-effects-panel/components/slideshow-item-glow-effect-options/slideshow-item-glow-effect-options';
import {GlowEffectOptions} from '@Panels/poster-editor-item-effects-panel/components/glow-effect-options';

export function ItemMobileGlowEffectOptions({...props}: ItemMobileGlowEffectOptionsProps): ReactElement | null {
  const getItemMobileGlowEffectOptions = (): ReactElement | null => {
    if (!props.itemType) {
      return null;
    }

    switch (props.itemType) {
      case ITEM_TYPE.SLIDESHOW:
        return <SlideshowItemGlowEffectOptions panelId={props.panelId} onClickColorFill={props.onClickColorFill} />;
      default:
        return <GlowEffectOptions onClickColorFill={props.onClickColorFill} panelId={props.panelId} />;
    }
  };

  return getItemMobileGlowEffectOptions();
}
